module.exports = __webpack_public_path__ + "static/img/dl_Phantom.fd1832e5.png";